import { getPartnerDetails, IPartnerIndex } from '@viabizzuno/models';
import { getLayout } from '@viabizzuno/models/server';
import { LayoutDefault } from '@viabizzuno/ui';
import { asEquatable, IStaticContext, PageProps } from '@websolutespa/bom-core';
import { getPage, getPageProps, getStaticPathsForSchema } from '@websolutespa/bom-mixer-models/server';
import { LazyLoader, OpenGraph, StructuredData } from '@websolutespa/bom-mixer-ui';


export default function PartnerIndex({ layout, page }: PageProps<IPartnerIndex>) {
  return (
    <>
      <LazyLoader components={page.components} />
      <StructuredData />
      <OpenGraph item={(metaData) => ({
        ...metaData.openGraph,
        image: page.media?.url,
      })} />
    </>
  );
}

PartnerIndex.Layout = LayoutDefault;


export async function getStaticProps(context: IStaticContext) {
  const id = asEquatable(context.params.id);
  const market = context.params.market;
  const locale = context.params.locale;
  const layout = await getLayout(market, locale);
  const page = await getPage<IPartnerIndex>('partner_index', id, market, locale);

  if (!page) {
    return {
      notFound: true,
      revalidate: true,
    };
  }

  const components = page.components || [];
  components.push({
    schema: 'block_hero_text',
  });
  components.push({
    schema: 'block_lab_index',
    //items: (await getPartnerDetails({ market, locale, sort: 'title' })),
    items: (await getPartnerDetails({ market, locale })).sort((a, b) => a.title.localeCompare(b.title)),
  });
  page.components = components;

  const props = await getPageProps({ ...context, layout, page });
  return {
    props,
    revalidate: 60 * 60 * 2, // revalidate
  };
}

export async function getStaticPaths() {
  const paths = await getStaticPathsForSchema('partner_index');
  return {
    paths,
    fallback: 'blocking', // runs before initial render
    // fallback: true, // runs in the background
  };
}

